import { render, staticRenderFns } from "./ztfpList.vue?vue&type=template&id=bbf40fc2&scoped=true&"
import script from "./ztfpList.vue?vue&type=script&lang=js&"
export * from "./ztfpList.vue?vue&type=script&lang=js&"
import style0 from "./ztfpList.vue?vue&type=style&index=0&id=bbf40fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf40fc2",
  null
  
)

export default component.exports